// extracted by css-extract-rspack-plugin
export default {"Details":"OpportunityCard_Details__Hnzcr","BannerSkeleton":"OpportunityCard_BannerSkeleton__Vu+zH","TitleSkeleton":"OpportunityCard_TitleSkeleton__ezVow"};